import { render, staticRenderFns } from "./MatchupChartResult.vue?vue&type=template&id=587a9a78&scoped=true"
import script from "./MatchupChartResult.vue?vue&type=script&lang=ts"
export * from "./MatchupChartResult.vue?vue&type=script&lang=ts"
import style0 from "./MatchupChartResult.vue?vue&type=style&index=0&id=587a9a78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a9a78",
  null
  
)

export default component.exports